var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportName.data != null)?_c('div',[_vm._v(" "+_vm._s(_vm.reportName.data)+" ")]):_c('div',[_vm._v(" "+_vm._s("N/A")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }